export default __webpack_public_path__ + "static/media/IconDesc_HazmatSuit.256.a7cb7f32.png";